import { ErrorMessage } from 'formik'
import * as React from 'react'
import { JobField } from 'epc-schema'
import { Form, Input } from 'ui'
import { useJobFieldsQuery } from './graphql'

export type JobFieldSelectFn = (job: string) => void

interface IJobFieldLowerLevelProps {
  name: string
  label?: string
  description?: string
  value: string
  onDismiss: () => void
  onSelect: JobFieldSelectFn
  placeholder: string
  disabled?: boolean
  required?: boolean
}

export const JobFieldLowerLevelSelectField: React.FunctionComponent<
  IJobFieldLowerLevelProps
> = (props) => {
  const { data, loading, networkStatus } = useJobFieldsQuery({
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })
  const jobFields = (data && data.response && data.response.jobFields) || null
  return (
    <Input.FieldContainer disabled={props.disabled}>
      {props.label ? (
        <Form.Label>
          {props.label} {props.required ? <Form.RequiredIcon /> : null}
        </Form.Label>
      ) : null}
      {props.description ? (
        <Form.Descriptive>{props.description}</Form.Descriptive>
      ) : null}
      <Input.Dropdown
        value={props.value}
        placeholder={props.placeholder}
        onDismiss={props.onDismiss}
        pushContent={true}
        loading={loading || networkStatus === 4}
      >
        {(searchValue, dismiss) => (
          <React.Fragment>
            {!jobFields
              ? null
              : jobFields
                  .map((j) => (j as JobField).field)
                  .filter(
                    (field) =>
                      field.toLowerCase().indexOf(searchValue.toLowerCase()) >
                      -1
                  )
                  .reduce(
                    (p: string[], c) => (p.indexOf(c) < 0 ? [...p, c] : p),
                    []
                  )
                  .sort((a, b) => (a > b ? 1 : a < b ? -1 : 0))
                  .map((field) => {
                    const onClick: React.MouseEventHandler = (e) => {
                      e.stopPropagation()
                      props.onSelect(field)
                      dismiss()
                    }
                    return (
                      <Input.AutocompleteSuggestion
                        key={`${props.name}JobFieldSearchResult${field}`}
                        displayName={
                          <Input.SuggestionDetailView heading={field} />
                        }
                        onClick={onClick}
                      />
                    )
                  })}
          </React.Fragment>
        )}
      </Input.Dropdown>
      <ErrorMessage name={props.name} component={Input.Error} />
    </Input.FieldContainer>
  )
}
